import React, { useEffect, useState, useRef } from 'react';
//import RichTextEditor from 'react-rte';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const TextEditor = (props) => {
  const quillRef = useRef(null);
  const { onChange, textLength, htmlText, hasValue, ariaLabel = 'Text editor' } = props;
  const [richTextEditor, setRichTextEditor] = useState(htmlText);
  const [initialized, setInitialized] = useState(false);
  const height = 100;
  let isEmpty = true;
  useEffect(() => {
    const editor = quillRef.current.getEditor()
    const html = editor.root.innerHTML; // Get editor content as HTML
    editor.root.parentElement.style.height = `${height}px`;
    isEmpty = html === "<p><br></p>";//.getEditorState().getCurrentContent().hascreateEmptyValueText();
    document.querySelector('.ql-italic') && document.querySelector('.ql-italic').setAttribute('title', 'Italic');
    document.querySelector('.ql-bold') && document.querySelector('.ql-bold').setAttribute('title', 'Bold');
    document.querySelector('.ql-underline') && document.querySelector('.ql-underline').setAttribute('title', 'Underline');
    document.querySelector('.ql-link') && document.querySelector('.ql-link').setAttribute('title', 'Link');
    document.querySelector('.ql-strike') && document.querySelector('.ql-strike').setAttribute('title', 'Strike');
  
    document.querySelector('.ql-italic') && document.querySelector('.ql-italic').setAttribute('aria-label', 'Italic');
    document.querySelector('.ql-bold') && document.querySelector('.ql-bold').setAttribute('aria-label', 'Bold');
    document.querySelector('.ql-underline') && document.querySelector('.ql-underline').setAttribute('aria-label', 'Underline');
    document.querySelector('.ql-link') && document.querySelector('.ql-link').setAttribute('aria-label', 'Link');
    document.querySelector('.ql-strike') && document.querySelector('.ql-strike').setAttribute('aria-label', 'Strike');
    
    
    document.querySelector('button.ql-list[value="ordered"]') && document.querySelector('button.ql-list[value="ordered"]').setAttribute('aria-label', 'Ordered List');
    document.querySelector('button.ql-list[value="bullet"]') && document.querySelector('button.ql-list[value="bullet"]').setAttribute('aria-label', 'Bullet List');
    document.querySelector('button.ql-list[value="ordered"]') && document.querySelector('button.ql-list[value="ordered"]').setAttribute('title', 'Ordered List');
    document.querySelector('button.ql-list[value="bullet"]') && document.querySelector('button.ql-list[value="bullet"]').setAttribute('title', 'Bullet List');
   }, [])
  const modules = {
    toolbar: [
      [{ 'bold': 'bold' }, { 'italic': 'italic' }, { 'underline': 'underline' }, { 'strike': 'strike' }], // Keep basic formatting
      [{ list: 'ordered' }, { list: 'bullet' }], // Keep list dropdown
      [{ 'link': 'link' }],
    ],
  };

  useEffect(() => {
    const editorElement = document.querySelector('.ql-editor');
    const editorElementDraftStyle = document.querySelector('.public-DraftStyleDefault-block');
    if (editorElement && !editorElementDraftStyle) {
      editorElement.classList.add('public-DraftStyleDefault-block');
    }
  })
  useEffect(() => {
    if (!initialized && hasValue && htmlText && isEmpty) {
      setRichTextEditor(htmlText);
      textLength(getTextLength(htmlText));
      setInitialized(true);
    }
  }, [htmlText]);

  const handleText = (rte) => {
    const textEditorValue = rte.toString('html');
    textLength(getTextLength(textEditorValue));
    setRichTextEditor(rte);
    onChange(textEditorValue);
  };

  const getTextLength = (htmlText) => {
    const regex = /(<([^>]+)>)/gi;
    const textWithoutTags = htmlText.replace(regex, '').replace('&nbsp;', ' ');
    return textWithoutTags.length;
  };

  return (
    <ReactQuill theme="snow"
      ref={quillRef}
      modules={modules}
      className={'text-editor-wrapper'}
      aria-label={ariaLabel || "Rich text editor for writing content"}
      aria-labelledby="editor-label"
      value={richTextEditor}
      role="textbox" // Defines it as a text-editable area
      aria-multiline="true"
      onChange={handleText}
    />
  );
};

export default TextEditor;
